// @flow

import createImmutableSelector from 'create-immutable-selector';
import { connect } from 'react-redux';
import {
  vehiclesFilteredBySearchSelector,
  bookingsFilteredBySearchSelector
} from 'modules/commuteOffer/selectors';
import { changeBookingsFilter } from 'modules/ui/actions';

import Filter from './Filter';

const mapStateToProps = createImmutableSelector(
  vehiclesFilteredBySearchSelector,
  bookingsFilteredBySearchSelector,
  (vehicles, bookings) => ({ vehicles, bookings })
);
const mapDispatchToProps = {
  changeBookingsFilter
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withConnect(Filter);
